var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"four"},[_c('img',{attrs:{"src":require("../../assets/State/404.png"),"alt":""}}),_c('p',[_vm._v(" 呃，非常抱歉，数据加载失败"),_c('br'),_vm._v(" 您可以尝试"),_c('span',{on:{"click":_vm.link}},[_vm._v("重新加载")])])])}
var staticRenderFns = []

export { render, staticRenderFns }